import { render, staticRenderFns } from "./news9.vue?vue&type=template&id=f6ccc88e&scoped=true&"
import script from "./news9.vue?vue&type=script&lang=js&"
export * from "./news9.vue?vue&type=script&lang=js&"
import style0 from "./news9.vue?vue&type=style&index=0&id=f6ccc88e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ccc88e",
  null
  
)

export default component.exports